import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { PurchasingSupplier } from '@Purchasing/Domain/Model/PurchaseProcess'
import {
    CreatePurchasingSupplierPayload,
    UpdatePurchasingSupplierPayload,
} from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'
import { useCallback, useEffect, useState } from 'react'

export const usePurchasingSuppliers = () => {
    const listUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseGetPurchasingSuppliers
    )
    const searchUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseSearchPurchasingSuppliers
    )
    const createUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseCreatePurchasingSupplier
    )
    const updateUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseUpdatePurchasingSupplier
    )

    const [suppliers, setSuppliers] = useState<PurchasingSupplier[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const load = useCallback(async () => {
        setLoading(true)
        try {
            const result = await listUseCase.execute({ active: true })
            setSuppliers(result ?? [])
        } catch (e) {
            console.error(e)
            setSuppliers([])
        }
        setLoading(false)
    }, [listUseCase])

    const search = useCallback(
        async (query: string) => {
            if (!query) return load()
            setLoading(true)
            try {
                const result = await searchUseCase.execute(query)
                setSuppliers(result ?? [])
            } catch (e) {
                console.error(e)
                setSuppliers([])
            }
            setLoading(false)
        },
        [searchUseCase, load]
    )

    const createSupplier = useCallback(
        async (payload: CreatePurchasingSupplierPayload) => {
            setError(null)
            try {
                return await createUseCase.execute(payload)
            } catch (e: any) {
                console.error(e)
                setError(e?.response?.data?.message ?? 'Erro ao criar fornecedor')
                return null
            }
        },
        [createUseCase]
    )

    const updateSupplier = useCallback(
        async (id: string, payload: UpdatePurchasingSupplierPayload) => {
            setError(null)
            try {
                return await updateUseCase.execute(id, payload)
            } catch (e: any) {
                console.error(e)
                setError(e?.response?.data?.message ?? 'Erro ao atualizar fornecedor')
                return null
            }
        },
        [updateUseCase]
    )

    useEffect(() => {
        load()
    }, [load])

    return {
        suppliers,
        loading,
        error,
        reload: load,
        search,
        createSupplier,
        updateSupplier,
    }
}
